import { css } from 'twin.macro';
import ShareBtn from '@/components/ShareBtn/ShareBtn';
import AudioPlayerWithTranscript from './AudioPlayerWithTranscript';

const AudioPlayer = ({ image, className, mimetype, transcriptions }) => {
    return (
        <div
            key={image}
            css={css`
                display: flex;
                flex-direction: column;
                position: relative;
                :hover .shareBtn {
                    opacity: 1;
                    z-index: 200;
                }
            `}
        >
            <ShareBtn url={image} />
            <div
                css={css`
                    margin-top: 1rem;
                `}
            >
                <audio controls className={className}>
                    <source src={image} type={mimetype} />
                    Your browser does not support HTML audio.
                </audio>
            </div>
            <div
                css={css`
                    display: flex;
                    justify-content: flex-end;
                `}
            >
                <AudioPlayerWithTranscript url={image} transcriptions={transcriptions} />
            </div>
        </div>
    );
};

export default AudioPlayer;
